export default __webpack_public_path__ + "locales/sq-AL/FilesSettings.json?hash=6ab2c459f5987cea7cebb6d93d653b79";